import Link from 'next/link';
import { PublisherInfoProps } from './PublisherInfo.types';

import { c } from '../../../utils/tailwind-merge';
import { Avatar } from '../../atoms/Avatar/Avatar';
import { CertifiedPublisher } from '../CertifiedPublisher';

export const PublisherInfo = ({
  publisherName,
  publisherLink,
  showAvatar,
  isCertified,
  publisherAccountType,
  microcopy,
  size = 'medium',
  publisherAvatarUrl,
  className = '',
}: PublisherInfoProps) => {
  const avatarSize = size === 'big' ? 44 : 24;

  const textClass = size === 'small' ? 'text-xs' : 'text-sm';

  const avatarProps = {
    userName: publisherName,
    userProfilePicture: publisherAvatarUrl,
    size: avatarSize,
    className: 'bg-grey-900',
  };

  const verifiedLabel =
    publisherAccountType === 'organization'
      ? microcopy.verifiedOrganization
      : publisherAccountType === 'individual'
        ? microcopy.verifiedIndividual
        : undefined;
  const showVerifiedBadge = isCertified && !!verifiedLabel;

  return (
    <div
      data-test="publisher-name-section"
      className={c('flex items-center', className)}
    >
      {showAvatar &&
        (publisherLink ? (
          <Link href={publisherLink} aria-hidden tabIndex={-1}>
            <Avatar {...avatarProps} className="text-white" />
          </Link>
        ) : (
          <Avatar {...avatarProps} className="text-white" />
        ))}
      <div
        className={c(
          'flex min-w-0 flex-1 flex-wrap items-center gap-x-2 gap-y-1',
          showAvatar ? 'pl-2' : ''
        )}
      >
        {publisherLink ? (
          <Link
            href={publisherLink}
            className={c(
              'min-w-0 max-w-full leading-5 text-grey-900',
              textClass
            )}
          >
            <span className="block whitespace-normal break-words">
              {publisherName}
            </span>
          </Link>
        ) : (
          <span
            className={c(
              'min-w-0 max-w-full leading-5 text-grey-900',
              textClass
            )}
          >
            <span className="block whitespace-normal break-words">
              {publisherName}
            </span>
          </span>
        )}

        {showVerifiedBadge && (
          <CertifiedPublisher
            text={verifiedLabel}
            microcopy={microcopy.certifiedPublisher}
          />
        )}
      </div>
    </div>
  );
};
